import { useEffect } from 'react';
import proptypes from 'prop-types';
const { node } = proptypes;
import { useHelmet, MetaTag, LinkTag } from '@thd-nucleus/thd-helmet';
import { HD_URL } from '../constants';
import { generateTags } from '../utils/generate-tags';

const getTitle = (title, dataTitle) => {
  if (!title && !dataTitle) {
    return null;
  }
  const primaryTitle = title || dataTitle;
  return (primaryTitle.toLowerCase()).includes('the home depot') ? primaryTitle : `${primaryTitle} - The Home Depot`;
};

const getDescription = (description, dataDescription) => {
  return description || dataDescription || null;
};

const getCanonical = (canonicalURL) => {
  if (!canonicalURL) {
    return null;
  }
  return `${HD_URL}${canonicalURL}`;
};

const metadataHandler = ({ props }) => {
  const { data, title = '', description = '' } = props;
  const {
    canonicalURL,
    description: dataDescription,
    siteName: ogSiteName,
    title: dataTitle,
    ogDescription,
    ogImage,
    ogType,
    ogTitle,
    facebookAdmins: fbAdmins,
    robots,
    mobile
  } = data || {};

  const defaultTitle = getTitle(title, dataTitle);
  const defaultDescription = getDescription(description, dataDescription);
  const canonical = getCanonical(canonicalURL);

  const tags = generateTags({
    canonical,
    description: defaultDescription,
    fbAdmins,
    ogDescription: ogDescription || defaultDescription,
    ogImage,
    ogSiteName,
    ogTitle,
    ogType,
    ogUrl: canonical,
    title: defaultTitle
  });

  if (robots) tags.push(new MetaTag({ name: 'robots', content: robots, id: 'robots' }));
  if (mobile) tags.push(new LinkTag({ rel: 'alternate', href: mobile, id: 'mobile' }));

  const dataKeys = data && Object.keys(data);
  if (!dataKeys?.length) return tags;

  dataKeys.forEach((tag) => {
    const content = data[tag] || '';
    if (tag === '__typename') return;
    if (tag.includes('alternateUrl')) {
      const langSubString1 = tag.substr(12, 2).toLowerCase();
      const langSubString2 = tag.substr(14, 2).toLowerCase() ? `-${tag.substr(14, 2).toLowerCase()}` : '';
      const hrefLang = `${langSubString1}${langSubString2}`;

      tags.push(new LinkTag({ rel: 'alternate', href: content, hreflang: hrefLang, id: `alternate-${hrefLang}` }));
    }
  });

  return tags;
};

const Metadata = (props) => {
  const { children } = props;

  useHelmet('rootMetadataHandler', { props }, metadataHandler, [props]);
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('metadata.ready'); }, []);

  return (
    children || null
  );
};

Metadata.propTypes = {
  children: node,
};

Metadata.defaultProps = {
  children: null,
};

export { Metadata };
